import { render, staticRenderFns } from "./BuildingPackageElectricity.vue?vue&type=template&id=0a43c426"
import script from "./BuildingPackageElectricity.vue?vue&type=script&lang=ts"
export * from "./BuildingPackageElectricity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports